<template>
  <section class="people">
    <div class="section-wrap">
      <Header dark :trigger="trigger"/>
    </div>
    <div class="container">
      <h1 class="people__head">we are a team full of talented people that can create products in many areas.</h1>
      <p class="people__text">we are covered in all areas. development, design and communication.</p>
      <div class="people__list-wrap">
        <ul class="people__list">
          <li class="people__list__person">
            <img class="people__list__person__image" :src="frede" alt="flot udvikler">
            <div class="people__list__person__details">
              <div class="people__list__person__details__titles">
                <h2 class="people__list__person__name">frederik</h2>
                <h3 class="people__list__person__title">developer & partner</h3>
              </div>
            </div>
          </li>
          <li class="people__list__person">
            <img class="people__list__person__image" :src="mikse" alt="flot designer">
            <div class="people__list__person__details">
              <div class="people__list__person__details__titles">
                <h2 class="people__list__person__name">mikkel</h2>
                <h3 class="people__list__person__title">designer & partner</h3>
              </div>
            </div>
          </li>
          <li class="people__list__person">
            <img class="people__list__person__image" :src="aleksis" alt="flot manager">
            <div class="people__list__person__details">
              <div class="people__list__person__details__titles">
                <h2 class="people__list__person__name">aleksander</h2>
                <h3 class="people__list__person__title">manager & partner</h3>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import './style.scss';
import frede from '@/assets/frede.png';
import mikse from '@/assets/mikse.png';
import aleksis from '@/assets/aleksis.png';
import Header from '@/components/Header/Header';


export default {
  name: 'People',
  data() {
    return {
      frede,
      mikse,
      aleksis,
    };
  },
  methods: {
  },
  components: {
    Header,
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/People/People.vue